import { FC, useContext, useEffect, useState } from "react";
import { GroupBase, OptionsOrGroups } from "react-select";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { format, parse, subDays } from "date-fns";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { useDebouncedCallback } from "use-debounce";
import { limitShift, offset, shift } from "@floating-ui/react";

import { AuthContext } from "src/context/authContext";
import useFetch from "src/hooks/useFetch";

import { isIoveraUser, isZilrettaUser } from "src/helpers";
import { APIEndpoints } from "src/types/apiTypes";
import HubInputField from "src/components/inputType";
import { DRUG_NAME, StatisticsProps } from "./types";
import { PatientFilterState, TerritoryDropdownResponseType } from "src/pages/actionDashboard/types";




const ActionDashBoardFilter: FC<StatisticsProps> = ({ updateQueryParams, defaultQueryParams, region_dropdown,activeTab }): JSX.Element => {
  // const [filteredDocListing, updatedFilteredDocListing] = useState<{ id: number; name: string; }[]>([])
  // const [filteredPracticeListing, updatedFilteredPracticeListing] = useState<{ id: number; name: string; }[]>([])
  const [territoryDropdown, updateTerritoryDropdown] = useState<string[]>([])
  // const [regionDropdown, updateRegionDropdown] = useState<string[]>(region_dropdown)
  const [stateDropdown, updateStateDropdown] = useState<string[]>()
  const { userData } = useContext(AuthContext)

  const { control, handleSubmit, reset, getValues, watch, resetField, setValue } = useForm<PatientFilterState>({
    mode: 'all',
    defaultValues: {
      ...defaultQueryParams,
      start_date: activeTab.includes("copay_claims")  ? format((new Date()).setDate((new Date()).getDate() - 90), "yyyy-MM-dd") : format((new Date()).setDate((new Date()).getDate() - 30), "yyyy-MM-dd"),
      drug_id: isZilrettaUser(userData) ? 'zilretta' : (isIoveraUser(userData) ? 'iovera°' : ''),
    },
  });

  const today = new Date();
  const hundredDaysAgo = subDays(today, 100);
  const start_date = watch("start_date");
  const end_date = watch("end_date");
  const drug = watch("drug_id");
  const selectedRegion = watch("region")
  const territory = watch("territory");

  console.log("Active Tab in Filter Component...",activeTab)


  useEffect(() => {
  const days = activeTab.includes("copay_claims") ? 90 : 30;

  const newStartDate = format(
    subDays(new Date(), days),
    "yyyy-MM-dd"
  );

  setValue("start_date", newStartDate);
}, [activeTab, setValue]);
  useEffect(() => {
    if (["Manufacturer", "fam_rm", "regional_manager"].includes(userData?.ref_type ?? "")) {
      if (typeof selectedRegion !== "string") {
        const region = (selectedRegion as unknown as { value: string })?.value?.toLowerCase() ?? "";
        console.log("region....",region)
        region && setValue("drug_id", region?.startsWith("i") ? "iovera°" : region?.startsWith("z") || region?.startsWith("j") ? "zilretta" : "");
        resetField("territory")
        resetField("state")
        updateTerritoryDropdown([])
        updateStateDropdown([])
      } 
      // else if (typeof selectedRegion === "string") {
      //   resetField("territory")
      //   resetField("state")
      //   //resetField("drug_id")
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRegion]);

  useEffect(() => {
    if (["Manufacturer", "fam_rm", "regional_manager", "district_manager"].includes(userData?.ref_type ?? "")) {
      if (typeof territory !== "string") {
        const territoryVal = (territory as unknown as { value: string })?.value?.toLowerCase() ?? "";
      territoryVal &&  setValue("drug_id", territoryVal?.startsWith("i") ? "iovera°" : territoryVal?.startsWith("z") || territoryVal?.startsWith("j") ? "zilretta" : "");
        resetField("state")
        updateStateDropdown([])
      } 
      // else if (typeof selectedRegion === "string") {
      //   resetField("state")
      //  // resetField("drug_id")
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [territory]);

  // useEffect(()=>{
  //   console.log(drug)
  //   resetField("territory")
  //   resetField("region")
  //   resetField("state")

  // },[drug])



  const { data: territoryDropdownData, error: territoryDropdownError, mutate: territoryDropdownMutate } =
    useFetch<TerritoryDropdownResponseType>(APIEndpoints.TERRITORY_DROPDOWN, {}, {}, false);

  useEffect(() => {
    if (territoryDropdownData || territoryDropdownError) {
      if (territoryDropdownData && territoryDropdownData.data) {
        updateTerritoryDropdown(territoryDropdownData?.data)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [territoryDropdownData, territoryDropdownError]);



  const { data: stateDropdownData, error: stateDropdownError, mutate: stateDropdownMutate } =
    useFetch<TerritoryDropdownResponseType>(APIEndpoints.STATE_DROPDOWN, {}, {}, false);

  useEffect(() => {
    if (stateDropdownData || stateDropdownError) {
      if (stateDropdownData && stateDropdownData.data) {
        updateStateDropdown(stateDropdownData?.data)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateDropdownData, stateDropdownError]);



  const { data: practiceListing, mutate: getPracticeListing } = 
    useFetch<{ id: number; name: string; }[]>(APIEndpoints.AD_PRACTICE_DROPDOWN, {}, {}, false)

  //:- Filtering practice from api recieved listing
  const filterPractice = (search: string) => {
    //console.log("Search...... in filterPractice", search)
    if (search.length >= 2) {
      getPracticeListing({}, {}, { query: search })
      // updatedFilteredPracticeListing(
      //   practiceDropdown.filter((prac) => prac.name.toLowerCase().includes(search.toLowerCase()))
      // )
    }
  };
  const debouncedFilterPractice = useDebouncedCallback(filterPractice, 500);



  const { data: providersListing, mutate: getProvidersListing } = 
    useFetch<{ id: number; name: string; }[]>(APIEndpoints.AD_PROVIDER_DROPDOWN, {}, {}, false)

  //:- Filtereing doctor from api recieved listing
  const filterDoctor = (search: string) => {
    //console.log("Search...... in filterDoctor", search)
    if (search.length >= 2) {
      getProvidersListing({}, {}, { query: search })
      // updatedFilteredDocListing(
      //   doctorDropdown.filter((doc) => doc.name.toLowerCase().includes(search.toLowerCase()))
      // )
    }
  };
  const debouncedFilterDoctor = useDebouncedCallback(filterDoctor, 500);



  const searchForStats = (values: PatientFilterState) => {
    const updatedValues = {
      ...defaultQueryParams,
      ...values,
      global_doctor_id:
        values.global_doctor_id ?
          (typeof values.global_doctor_id === "string" ? values.global_doctor_id : (values.global_doctor_id as unknown as { value: string; label: string; }).value)
          : "",
      drug_id:
        values.drug_id
          ? (typeof values.drug_id === "string"
            ? values.drug_id === "All Products"
              ? ""
              : values.drug_id
            : (values.drug_id as { value: string; label: string }).value === "All Products"
              ? ""
              : (values.drug_id as { value: string; label: string }).value)
          : "",
      practice_id:
        values.practice_id ?
          (typeof values.practice_id === "string" ? values.practice_id : (values.practice_id as unknown as { value: string; label: string; }).value)
          : "",
      region:
        values.region ?
          (typeof values.region === "string" ? values.region : (values.region as unknown as { value: string; label: string; }).value)
          : "",
      territory:
        values.territory ?
          (typeof values.territory === "string" ? values.territory : (values.territory as unknown as { value: string; label: string; }).value)
          : "",
      state:
        values.state ?
          (typeof values.state === "string" ? values.state : (values.state as unknown as { value: string; label: string; }).value)
          : "",
    };
    //console.log("updatedValues....", updatedValues)

    const region = updatedValues.region?.toLowerCase().trim() || "";
    const territory = updatedValues.territory?.toLowerCase().trim() || "";

    if (!region && !territory) {
      console.log("DrugID",{drug})
      // don't send drug_id if nothing is selected
    } else {
      updatedValues.drug_id =
        region.startsWith("z") ||
          region.startsWith("j") ||
          territory.startsWith("z") ||
          territory.startsWith("j")
          ? "zilretta"
          : "iovera";
    }
    console.log("Updated Values ....",updatedValues)
    updateQueryParams(updatedValues, false);
  };

  const clearFormData = () => {
    //console.log("defaultQueryParams......", defaultQueryParams)
    const values = {
      ...defaultQueryParams,
      start_date: activeTab.includes("copay_claims")  ? format((new Date()).setDate((new Date()).getDate() - 90), "yyyy-MM-dd") : format((new Date()).setDate((new Date()).getDate() - 30), "yyyy-MM-dd"),
      end_date: format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
      practice_id: "",
      global_doctor_id: "",
      case_id: "",
      global_patient_id: "",
      region: "",
      territory: "",
      state: '',
      //drug_id:""
      drug_id: isZilrettaUser(userData) ? 'zilretta' : (isIoveraUser(userData) ? 'iovera°' : '')
    };
    // updateRegionDropdown([])
    updateTerritoryDropdown([])
    updateStateDropdown([])
    reset(values);
    // updatedFilteredDocListing([]);
    // updatedFilteredPracticeListing([]);
    updateQueryParams(getValues(), true);
  };

  useEffect(() => {
    if (userData?.ref_type === "district_manager" && region_dropdown.length > 0) {
       //console.log("Region Dropdown....",region_dropdown)
      const params = { ...defaultQueryParams, "district_geography_name": (region_dropdown[0]) }
      territoryDropdownMutate({}, {}, params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [region_dropdown])

  return (
    <form className="row g-2 filters" onSubmit={handleSubmit(searchForStats)}>
      <div className="col product-field mb-2">
        <Controller
          name="drug_id"
          control={control}
          defaultValue={""}
          render={({ field }) => (
            <Select
              id="drug_id"
              placeholder="Select Drug"
              isClearable={false}
              isSearchable={false}
              isDisabled={isZilrettaUser(userData) || isIoveraUser(userData)}
              options={
                DRUG_NAME.map((item) => ({
                  value: item.value,
                  label: item.label,
                }))
              }
              // current value ko properly map karna zaroori hai
              value={DRUG_NAME.find((item) => item.value === (field?.value ?? ''))}
              onChange={(selectedOption) =>{
                field.onChange(selectedOption ? selectedOption.value : "")
                if (selectedOption && selectedOption.value !== field.value) {
                      resetField("region")
                      resetField("territory")
                      resetField("state")
                      updateTerritoryDropdown([])
                      updateStateDropdown([])
                    } 
              }}
              onBlur={field.onBlur}
            />
          )}
        />
      </div>
      <div className="col date-field mb-2">
        <Controller
          name="start_date"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <DatePicker
              selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
              onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
              customInput={
                <ReactInputMask mask="99/99/9999">
                  {(inputProps: {} = { className: "form-control" }) =>
                    <input {...inputProps} />
                  }
                </ReactInputMask>
              }
              className="form-control" wrapperClassName="w-100"
              placeholderText="mm/dd/yyyy"
              dateFormat="MM/dd/yyyy"
              showMonthDropdown
              showYearDropdown
              // maxDate={end_date ? new Date(end_date) : undefined}
              maxDate={end_date ? new Date(end_date) : today}
              minDate={hundredDaysAgo} // limit user to 100 days in the past
              portalId="root"
              popperModifiers={[offset(8), shift({ limiter: limitShift() })]}
            />
          )}
        />
      </div>
      <div className="col date-field mb-2">
        <Controller
          name="end_date"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <DatePicker
              selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
              onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
              customInput={
                <ReactInputMask mask="99/99/9999">{(inputProps: {} = { className: "form-control" }) =>
                  <input {...inputProps} />
                }
                </ReactInputMask>
              }
              className="form-control" wrapperClassName="w-100"
              placeholderText="mm/dd/yyyy"
              dateFormat="MM/dd/yyyy"
              showMonthDropdown
              showYearDropdown
              //minDate={start_date ? new Date(start_date) : undefined}
              minDate={start_date ? new Date(start_date) : hundredDaysAgo}
              maxDate={today}
              portalId="root"
              popperModifiers={[offset(8), shift({ limiter: limitShift() })]}
            />
          )}
        />
      </div>

      {(userData?.ref_type === "Manufacturer" || userData?.ref_type === "regional_manager" || userData?.ref_type === "fam_rm") &&
        <div className="col mb-2">
          <Controller
            name="region"
            control={control}
            defaultValue={''}
            render={({ field }) => {
              // Filter regions based on selected drug
              const filteredRegions =
                region_dropdown && region_dropdown.length > 0
                  ? region_dropdown.filter((item: string) => {
                    if (drug && drug.includes("iov")) return item?.toLowerCase().startsWith("i");
                    if (drug && drug.includes("zil") && userData && userData.is_jnj) return (item?.toLowerCase().startsWith("j"));
                    if (drug && drug.includes("zil")) return (item?.toLowerCase().startsWith("z"))
                    return true; // fallback for other drugs
                  })
                  : [];

              return (
                <Select
                  id="region"
                  placeholder="Region"
                  isClearable={true}
                  isSearchable={true}
                  options={(
                    filteredRegions && filteredRegions.length > 0 ?
                      filteredRegions.map((item: string) => ({ value: item, label: item }))
                      : []
                  ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                  // current value ko properly map karna zaroori hai
                  value={
                    field.value
                      ? filteredRegions.find((item: string) => item === field.value)
                      : null
                  }

                  onChange={(selectedOption) => {
                    field.onChange(selectedOption ?? "");
                    if (selectedOption) {
                      const params = { ...defaultQueryParams, "district_geography_name": (selectedOption as unknown as { label: string }).label }
                      territoryDropdownMutate({}, {}, params);
                      resetField("territory")
                      resetField("state")
                      updateTerritoryDropdown([])
                      updateStateDropdown([])
                    } 
                    else {
                    resetField("territory")
                      resetField("state")
                      updateTerritoryDropdown([])
                      updateStateDropdown([])
                    }
                  }}
                  onBlur={field.onBlur}
                />
              );
            }}
          />
        </div>
      }
      {(userData?.ref_type === "Manufacturer" || userData?.ref_type === "regional_manager" || userData?.ref_type === "district_manager" || userData?.ref_type === "fam_rm") &&
        <div className="col mb-2">
          <Controller
            name="territory"
            control={control}
            defaultValue={""}
            render={({ field }) => {
              // Filter territories based on selected drug
              const filteredTerritories =
                territoryDropdown && territoryDropdown.length > 0
                  ? territoryDropdown.filter((item: string) => {
                    if (drug && drug.includes("iov") && (selectedRegion && (selectedRegion as unknown as { label: string }).label?.toLowerCase().startsWith("i"))) return item?.toLowerCase().startsWith("i");
                    if (drug && drug.includes("zil") && userData && userData.is_jnj) return (item.toLowerCase().startsWith("j"));
                    if (drug && drug.includes("zil") && (selectedRegion && (selectedRegion as unknown as { label: string }).label?.toLowerCase().startsWith("z"))) return (item?.toLowerCase().startsWith("z"))
                    if ((selectedRegion && (selectedRegion as unknown as { label: string }).label?.toLowerCase().startsWith("i"))) return item?.toLowerCase().startsWith("i");
                    if ((selectedRegion && (selectedRegion as unknown as { label: string }).label?.toLowerCase().startsWith("z"))) return (item?.toLowerCase().startsWith("z"))
                    return true; // fallback for other drugs
                  })
                  : [];

              return (
                <Select
                  id="territory"
                  placeholder="Territory"
                  isClearable={true}
                  isSearchable={true}
                  options={(filteredTerritories && filteredTerritories.length > 0 ?
                    filteredTerritories.map((item: string) => ({ value: item, label: item }))
                    : []
                  ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                  // current value ko properly map karna zaroori hai
                  value={
                    field.value
                      ? filteredTerritories.find((item: string) => item === field.value)
                      : null
                  }
                  onChange={(selectedOption) => {
                    field.onChange(selectedOption ?? "");
                    if (selectedOption) {
                      const params = { ...defaultQueryParams, "territory": (selectedOption as unknown as { label: string }).label }
                      stateDropdownMutate({}, {}, params);
                    } else {
                      resetField("state")
                      updateStateDropdown([])
                    }
                  }}
                  onBlur={field.onBlur}
                />
              );
            }}
          />
        </div>
      }
      {(userData?.ref_type === "Manufacturer" || userData?.ref_type === "regional_manager" || userData?.ref_type === "district_manager" || userData?.ref_type === "fam_rm") && 
        <div className="col state-field mb-2">
          <Controller
            name="state"
            control={control}
            defaultValue={""}
            render={({ field }) => {
              // Filter territories based on selected drug
              // const filteredState =
              //     state_dropdown && state_dropdown.length > 0
              //         ? state_dropdown.filter((item: string) => {
              //             // if (drug === "iovera°") return item.toLowerCase().startsWith("i");
              //             // if (drug === "zilretta") return (item.toLowerCase().startsWith("z") || item.toLowerCase().startsWith("j"));
              //             return true; // fallback for other drugs
              //         })
              //         : [];

              return (
                <Select
                  id="state"
                  placeholder="State"
                  isClearable={true}
                  isSearchable={true}
                  options={(stateDropdown && stateDropdown.length > 0 ?
                    stateDropdown.map((item: string) => ({ value: item, label: item }))
                    : []
                  ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                  // current value ko properly map karna zaroori hai
                  value={
                    field.value
                      ? stateDropdown && stateDropdown.length > 0 && stateDropdown.find((item: string) => item === field.value)
                      : null
                  }
                  onChange={(selectedOption) => {
                    field.onChange(selectedOption ?? "");
                    // if (selectedOption) {
                    //     const params = { ...defaultQueryParams, "state": (selectedOption as unknown as { label: string }).label }
                    //     stateDropdownMutate({}, {}, params);
                    // }
                  }}
                  onBlur={field.onBlur}
                />
              );
            }}
          />
        </div>
      }

      <div className="col mb-2">
        <Controller
          name="practice_id"
          control={control}
          render={({ field }) => (
            <Select
              options={(practiceListing && practiceListing.length > 0 ?
                practiceListing.map((item) => ({
                  value: item.id.toString(),
                  label: item.name
                }))
                : []
              ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
              id="practice_id"
              placeholder="Practice"
              isSearchable={true}
              isClearable={true}
              {...field}
              noOptionsMessage={() => "Please enter 2 or more characters to search..."}
              onInputChange={debouncedFilterPractice}
              // onMenuClose={() => updatedFilteredPracticeListing([])}
            />
          )}
        />
      </div>
      <div className="col mb-2">
        <Controller
          name="global_doctor_id"
          control={control}
          defaultValue={''}
          render={({ field }) => (
            <Select
              isClearable={true}
              options={(providersListing && providersListing.length > 0 ?
                providersListing.map((item) => ({
                  value: item.id.toString(),
                  label: item.name
                }))
                : []
              ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
              id="global_doctor_id"
              placeholder="Doctor"
              isSearchable={true}

              // placeholder="Enter Diagnosis Code"
              {...field}
              noOptionsMessage={() => "Please enter 2 or more characters to search..."}
              onInputChange={debouncedFilterDoctor}
              // onMenuClose={() => updatedFilteredDocListing([])}
            />
          )}
        />
      </div>
      <div className="col ID-field">
        <Controller
          name="global_patient_id"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <HubInputField
              inputId="global_patient_id"
              isRowBased={true}
              isRequired={false}
              field={field}
              inputPlaceholder="Pt. ID"
            />
          )}
        />
      </div>
      <div className="col ID-field">
        <Controller
          name="case_id"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <HubInputField
              inputId="case_id"
              isRowBased={true}
              isRequired={false}
              field={field}
              inputPlaceholder="Case ID"
            />
          )}
        />
      </div>
      <div className="col btn-col mb-2">
        <div className="row g-2">
          <div className="col-6">
            <button type="submit" className="btn btn-primary w-100">
              Search
            </button>
          </div>
          <div className="col-6">
            <button type="button" onClick={clearFormData} className="btn btn-outline-secondary w-100">
              Clear
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ActionDashBoardFilter;
